export class Cooker {
  constructor(_scene) {
    this._scene = _scene;
    this._queue = /* @__PURE__ */ new Map();
    this._blockLevel = 0;
    this._blockLevel = 0;
  }
  block() {
    this._blockLevel += 1;
  }
  unblock() {
    this._blockLevel -= 1;
    if (this._blockLevel < 0) {
      this._blockLevel = 0;
    }
    this._processQueue();
  }
  blocked() {
    return this._blockLevel > 0;
  }
  enqueue(node, original_trigger_graph_node) {
    this._queue.set(node.graphNodeId(), original_trigger_graph_node);
  }
  _processQueue() {
    if (this.blocked()) {
      return;
    }
    const nodes = [];
    const nodeIds = [];
    this._queue.forEach((node, nodeId) => {
      nodes.push(node);
      nodeIds.push(nodeId);
    });
    this._queue.clear();
    for (let i = 0; i < nodes.length; i++) {
      const node = nodes[i];
      const nodeId = nodeIds[i];
      this._processItem(node, nodeId);
    }
  }
  _processItem(original_trigger_graph_node, id) {
    const node = this._scene.graph.nodeFromId(id);
    if (node) {
      node.dirtyController.runPostDirtyHooks(original_trigger_graph_node);
    }
  }
}
